import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AuctionDetails from './AuctionDetailsForm';
import AddressForm from './AddressForm';
import Review from './Review';
import axios from 'axios';




// function Copyright() {
//     return (
//         <Typography variant="body2" color="textSecondary" align="center">
//         {'Copyright © '}
//         <Link color="inherit" href="#">
//             Transporex
//         </Link>{' '}
//         {new Date().getFullYear()}
//         {'.'}
//         </Typography>
//     );
//     }

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        background: '#303F9F',
        color: 'white'
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
        width: 600,
        marginLeft: 'auto',
        marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        color: 'white',
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        background: '#15616d',
        '&:hover': {
            color: 'white',
            textDecoration: 'none',
            background: '#40916c',
        }
    },
    link: {
        color: 'white',
        '&:hover': {
            color: 'white',
            textDecoration: 'none'
        }
    },

   // Stepper styles
    icon: {
        color: "#15616d !important"
    },
}));

const steps = ['Auction details', 'Address details', 'Review your auction'];

function getStepContent(step, auctionInfo, setAuctionInfo) {
    // 1.) Include parameters to capture data to start an auction
    // 2.) Pass the parameters which are sent as props to their individual components

    switch (step) {
        case 0:
        return <AuctionDetails auctionInfo={auctionInfo} setAuctionInfo={setAuctionInfo}/>;
        case 1:
        return <AddressForm auctionInfo={auctionInfo} setAuctionInfo={setAuctionInfo}/>;
        case 2:
        return <Review auctionInfo={auctionInfo} setAuctionInfo={setAuctionInfo}/>;
        default:
        throw new Error('Unknown step');
    }
    }

export default function CreateAuction() {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);

    // <---- Capture ALL created auction in a SINGLE Object state ---> //
    const [auctionInfo, setAuctionInfo] = useState({})

            
            const handleNext = (e) => {
                setActiveStep(activeStep + 1);
        //const submitAuction =  async (e) => {
                try {
                 return axios.post('/api/auctions', auctionInfo);
                    console.log("auction has been placed");
                } catch (error) {
                    console.log("place auction error", error);
                }
        
                e.preventDefault();
                
            };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    // const submitAuction =  async (e) => {




    return (
        <>
        <CssBaseline />
        {/* <AppBar position="absolute" className={classes.appBar}>
            <Toolbar>
            <Typography variant="h6" color="inherit" noWrap>
                <Link to='/' className={classes.link} color="inherit">Transporex</Link>
            </Typography>
            </Toolbar>
        </AppBar> */}
        <main className={classes.layout}>
            <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
                Create your auction
            </Typography>
            <Stepper  activeStep={activeStep} className={classes.root}>
                {steps.map((label) => (
                <Step key={label} >
                    <StepLabel 
                    StepIconProps={{
                        classes: {
                            active: classes.icon,
                            completed: classes.icon
                        }
                    }}
                    >
                    {label}
                    </StepLabel>
                </Step>
                ))}
            </Stepper>
            <>
                {activeStep === steps.length ? (
                <>
                    <Typography variant="h5" gutterBottom>
                    Thank you, placing your action with us.
                    </Typography>
                    <Typography variant="subtitle1">
                    Your order number is #0050. We have emailed your auction details and confirmation to
                    youremail@email.com.
                    </Typography>
                </>
                ) : (
                <>
                    {getStepContent(activeStep, auctionInfo, setAuctionInfo)}
                    <div className={classes.buttons}>
                    {activeStep !== 0 && (
                        <Button onClick={handleBack} className={classes.button}>
                        Back
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                    >
                        {activeStep === steps.length - 1 ? 'Place auction' : 'Next'}
                    </Button>
                    </div>
                </>
                )}
            </>
            </Paper>
            {/* <Copyright /> */}
        </main>
        </>
    );
}
